<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\n"' class="col-lg-6 col-sm-12 m-0 p-0 mx-auto mb-2" >
                <template #default>   <m-video v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.geramyan.com\/storage\/123\/watermarkvid1717280656660downloadfile-5.mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='"object-fit: cover;\nborder-radius: 25px;\n\n\n"' class="col-lg-12 m-0 p-0  shadow" ></m-video></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-single-page-1 v-bind='{...{"contentLink":"news-notice"},...{}}' :style='""' class="col-12 mb-5" ></m-single-page-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mSinglePage1 from '@moeinmdn/miw-alpha-components/src/package/Page/Single/SinglePage1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mVideo,mSinglePage1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
